import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Seo } from '@/components/seo/Seo';
import { Container } from '@/components/ui/Container';
import { siteConfig } from '@/data/site';
import { usePosts } from '@/hooks/usePosts';
import { API_BASE_URL } from '@/lib/apiBase';

const feedUrl = `${API_BASE_URL}/rss.xml`;

export const RssPage = () => {
  const { posts, isLoading } = usePosts();

  return (
    <>
      <Seo title="RSS Feed" description={`Subscribe to ${siteConfig.name}`} path="/rss" />
      <Container>
        <section className="section-stack prose-page">
          <div className="section-heading">
            <h1>RSS Feed</h1>
          </div>

          <p>
            Subscribe to <strong>{siteConfig.name}</strong> in your RSS reader using the link below.
          </p>

          <div>
            <a href={feedUrl} target="_blank" rel="noreferrer" className="prose__a">
              {feedUrl}
            </a>
          </div>

          <h2>Recent posts</h2>

          {isLoading ? (
            <p>Loading…</p>
          ) : (
            <ul className="prose__ul">
              {posts.map((post) => (
                <li key={post.slug} className="prose__li">
                  <Link to={`/posts/${post.slug}`} className="prose__a">
                    {post.title}
                  </Link>
                  {post.date && (
                    <span style={{ marginLeft: '0.5rem', opacity: 0.6 }}>
                      — {format(new Date(post.date), 'dd MMM yyyy')}
                    </span>
                  )}
                  {post.description && (
                    <p style={{ margin: '0.25rem 0 0' }}>{post.description}</p>
                  )}
                </li>
              ))}
            </ul>
          )}
        </section>
      </Container>
    </>
  );
};
